import Box from '@mui/material/Box';

import { EntityAboutPanel } from './EntityAboutPanel';
import { EntityDependenciesPanel } from './EntityDependenciesPanel';
import { EntityHowToUsePanel } from './EntityHowToUsePanel';
import { EntityUsefulLinksPanel } from './EntityUsefulLinksPanel';

export const EntityOverviewGrid = () => (
  <Box
    sx={{
      alignItems: 'start',
      display: 'grid',
      gap: 3,
      gridTemplateColumns: {
        lg: 'repeat(2, minmax(0, 1fr))',
        xs: 'minmax(0, 1fr)',
      },
    }}
  >
    <Box
      sx={{
        display: 'grid',
        gap: 3,
        minWidth: 0,
      }}
    >
      <EntityAboutPanel />
      <EntityDependenciesPanel />
    </Box>

    <Box
      sx={{
        display: 'grid',
        gap: 3,
        minWidth: 0,
      }}
    >
      <EntityHowToUsePanel />
      <EntityUsefulLinksPanel />
    </Box>
  </Box>
);
